export default function Mint() {
  return (
    <div className="h-screen flex justify-center items-center">
      <h1 className="text-5xl font-semibold text-white">Coming Soon</h1>
    </div>
  );
}

